import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useGetAllEngagementsQuery } from '../../../reduxToolkit/reducers/usersSlice';
import { Card, CardBody, Container, Nav, NavItem, NavLink } from 'reactstrap';
import AjaxSourcedData from '../../formsAndTable/tables/dataTables/dataSource/AjaxSourcedData';
import { getEngagedTableColumns } from '../../../data/formsAndTable/tables/dataTables/DataSource';
import Breadcrumbs from '../../../coreComponents/breadcrumbs';
import { ConditionalStyles } from 'react-data-table-component';
import { EngagementsTableData } from '../../../types/Tables';
import { EngagenemtStatus } from '../../../types/Engagements';
import { CSSObject } from 'styled-components';
import Error404 from '../../pages/others/errorPage/Error404';
import { NoDataComponent } from '../../formsAndTable/forms/formControls/NoDataComponent';
import { EngagementsHeadingTooltip } from '../components/EngagementsHeadingTooltip';

const engagementTabs = ['active', 'closed'];

const Engagement = () => {
  const { t, i18n } = useTranslation();
  const [totalRows, setTotalRows] = useState(0);
  const [page, setPage] = useState<number>(1);
  const [perPage, setPerPage] = useState<number>(50);
  const [sort, setSort] = useState<'asc' | 'desc'>('asc');
  const [sortKey, setSortKey] = useState('nextDeadline');
  const [search, setSearch] = useState('');
  const [debouncedSearch, setDebouncedSearch] = useState('');
  const [basicTab, setBasicTab] = useState({
    filter: 'active',
    tabIndex: '1',
  });

  const viewerTz = Intl.DateTimeFormat().resolvedOptions().timeZone;

  const {
    data: engagementsData,
    isLoading: isEngagementsLoading,
    isError,
    isFetching: isEngagementsFetching,
  } = useGetAllEngagementsQuery({
    page,
    perPage,
    sort,
    sortKey,
    search: debouncedSearch,
    filter: basicTab.filter,
  });

  useEffect(() => {
    const id = setTimeout(() => setDebouncedSearch(search.trim()), 400);
    return () => clearTimeout(id);
  }, [search]);

  useEffect(() => {
    if (engagementsData) {
      setTotalRows(engagementsData.total);
    }
  }, [engagementsData]);
  const conditionalRowStyles: ConditionalStyles<EngagementsTableData>[] = [
    {
      when: (row: EngagementsTableData) => row.status === EngagenemtStatus.CLOSED,
      style: {
        backgroundColor: 'var(--bs-danger-bg-subtle)',
        color: 'var(--bs-danger-text-emphasis)',
      } as CSSObject,
    },
  ];

  if (isError) return <Error404 />;
  return (
    <>
      <Breadcrumbs mainTitle={t('engagements.pageTitle')} tooltip={<EngagementsHeadingTooltip />} />
      <Container fluid>
        <Card>
          <CardBody>
            <Nav tabs className="sim-e-wrapper mt-3">
              {engagementTabs.map((item, index) => {
                console.log('engagementsData?.item[item]', item);
                return (
                  <NavItem key={index}>
                    <NavLink
                      tag="button"
                      type="button"
                      className={`txt-info !h4 f-w-500 ${basicTab.tabIndex === `${index + 1}` ? 'active' : ''}`}
                      onClick={() => {
                        setBasicTab({ filter: item, tabIndex: `${index + 1}` });
                        localStorage.setItem('engagement-tabs', `${index + 1}`);
                      }}
                    >
                      {t(`engagements.userStatus.${item}`, {
                        count: engagementsData?.counts[item],
                      })}
                    </NavLink>
                  </NavItem>
                );
              })}
            </Nav>

            <AjaxSourcedData
              //  key={"future"}
              data={engagementsData?.items}
              columns={getEngagedTableColumns(t, viewerTz)}
              pagination={true}
              paginationServer={true}
              paginationPerPage={perPage}
              paginationDefaultPage={1}
              paginationTotalRows={totalRows}
              onChangePage={(p) => setPage(p)}
              conditionalRowStyles={conditionalRowStyles}
              onChangeRowsPerPage={(newPerPage, p) => {
                setPerPage(newPerPage);
                setPage(1); // or p, depending on your UX
              }}
              /* (optional) server sorting */
              sortServer
              onSort={(column, direction) => {
                // column.selector or column.sortField depending on your column defs
                const key = (column as any).sortField ?? (column as any).selector;
                setSort(direction);
                setSortKey(key);
              }}
              defaultSortAsc={false}
              searchServer
              searchText={search}
              onSearch={(value) => {
                setSearch(value);
                setPage(1);
              }}
              // conditionalRowStyles={conditionalRowStyles}
              paginationRowsPerPageOptions={[10, 25, 50]}
              noDataComponent={<NoDataComponent />}
              loading={isEngagementsFetching || isEngagementsLoading}
            />
          </CardBody>
          {/* <CardBody>
            <AjaxSourcedData
              //  key={"future"}
              data={engagementsData?.items}
              columns={getEngagedTableColumns2(t, viewerTz)}
              pagination={true}
              paginationServer={true}
              paginationPerPage={perPage}
              paginationDefaultPage={1}
              paginationTotalRows={totalRows}
              onChangePage={(p) => setPage(p)}
              conditionalRowStyles={conditionalRowStyles}
              onChangeRowsPerPage={(newPerPage, p) => {
                setPerPage(newPerPage);
                setPage(1); // or p, depending on your UX
              }}
              sortServer
              onSort={(column, direction) => {
                const key = (column as any).sortField ?? (column as any).selector;
                setSort(direction);
                setSortKey(key);
              }}
              defaultSortAsc={false}
              searchServer
              searchText={search}
              onSearch={(value) => {
                setSearch(value);
                setPage(1);
              }}
              paginationRowsPerPageOptions={[10, 25, 50]}
              noDataComponent={<NoDataComponent />}
              loading={isEngagementsFetching || isEngagementsLoading}
            />
          </CardBody> */}
        </Card>
      </Container>
    </>
  );
};

export default Engagement;
